<template>
    <section>
        <h1 v-if="photos.length > 0 || isOwnProfile">Photos</h1>
        <div v-if="photos.length > 0 || isOwnProfile" class="photos">
            <input type="file" id="upload-file" @change="uploadPhoto" style="display: none" accept="image/*"/>

            <template v-for="photo in photos">
                <div class="photo-container">
                    <div class="photo" :style="`background-image: url('/profilePhotos/member_${memberId}/${photo.photoUrl}')`" @click.prevent="showInModal(photo)"></div>
                    <button v-if="isOwnProfile" class="photo-button" @click.prevent="deletePhoto(photo)" :disabled="deletingPhoto">Delete</button>
                    <!--<button v-if="!isOwnProfile" @click.prevent="reportPhoto(photo)">Report</button>-->
                </div>
            </template>

            <label v-if="isOwnProfile && !isUploading" class="add-photo" for="upload-file">Add a Photo</label>
            <button v-if="isOwnProfile && isUploading" class="add-photo" disabled>Uploading...</button>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import bus from '../GlobalBus'

    export default {
        name: 'PhotoManager',
        props: ['photos', 'isOwnProfile', 'memberId'],

        data(){
            return {
                isUploading: false,
                deletingPhoto: false
            }
        },

        methods: {
            uploadPhoto(e){
                let input = e.target,
                    file,
                    formData = new FormData();

                if (input.files.length === 0) {
                    return;
                }

                file = input.files[0];

                if (input.files[0].size > 2 * 1024 * 1024) {
                    return;
                }

                this.isUploading = true;

                formData.append('uploadedFile', file);

                axios.post('/api/photoUploader', formData).then(
                    (response) => {
                        console.log(response.data);
                        console.log(response);
                        this.isUploading = false;

                        if (!response.data.errors && response.data.response === 'success') {

                        }
                    }
                );
            },

            deletePhoto(photo){
                this.deletingPhoto = true;

                axios.post('/api/photoUploader/delete', {
                    photoId: photo.id
                }).then((response) => {
                    this.deletingPhoto = false;
                });
            },

            showInModal(photo){
                bus.$emit('openModal', `<img src="/profilePhotos/member_${this.memberId}/${photo.photoUrl}"/>`)
            }
        }

    }
</script>


// WEBPACK FOOTER //
// PhotoManager.vue?23c5c980